"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayOrderNode = void 0;
const lodash_1 = __importDefault(require("lodash"));
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'ARRAY-ORDER';
class ArrayOrderNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const { input } = params;
            return {
                ordered: lodash_1.default.orderBy(input, (item) => {
                    return !this.config.type || this.config.type === 'Object' ? lodash_1.default.get(item, this.config.key) : item;
                }, this.config.order === 'Descending' ? 'desc' : 'asc'),
            };
        };
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        //set up the basic outputParams schema
        const OutputParams = {
            type: 'object',
            properties: {
                ordered: {
                    items: BaseNode_1.BaseNode.getProp(this.config.type, 'Item'),
                    description: 'Ordered items',
                    type: 'array',
                    title: 'input',
                },
            },
        };
        const InputParams = {
            type: 'object',
            properties: {
                input: {
                    items: BaseNode_1.BaseNode.getProp(this.config.type, 'Item'),
                    description: 'Items to Order',
                    type: 'array',
                    title: 'input',
                },
            },
        };
        const ConfigParams = {
            type: 'object',
            properties: {
                order: {
                    description: 'Order',
                    type: 'string',
                    enum: ['Ascending', 'Descending'],
                    default: 'Ascending'
                },
                type: {
                    description: 'Type',
                    type: 'string',
                    enum: ['Date', 'Number', 'Object', 'String'],
                    default: 'Object'
                },
            },
        };
        if (!this.config.type || this.config.type === 'Object') {
            ConfigParams.properties.key = {
                description: 'Key',
                type: 'string',
            };
        }
        return Object.assign(Object.assign({}, Schema), { InputParams: InputParams, OutputParams: OutputParams, ConfigParams: ConfigParams });
    }
}
exports.ArrayOrderNode = ArrayOrderNode;
ArrayOrderNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Array Order',
    isIdempotent: true,
    primaryCategory: 'Collection',
};
//# sourceMappingURL=ArrayOrder.js.map